import {
  View,
  Text,
  Pressable,
  ScrollView,
  Platform,
  Modal,
} from "react-native";
import React, { useState } from "react";
import MainContainer from "components/MainContainer";
import { AccountStackParamList } from "navigation/types";
import BaseCard, { BaseCardListItem } from "components/BaseCard";
import Chevron from "components/Chevron";
import { AccountTicketDetails, TenantOptionsDetails } from "features/types";
import dayjs from "dayjs";
import Spacer from "components/Spacer";
import { NavigationProp, useNavigation } from "@react-navigation/native";
import { useAccount } from "hooks/useAccount";
import { useFetchTicketHistoryQuery } from "queries/ticket.queries";
import { Image } from "expo-image";
import Button from "components/Button";
import { printToFileAsync } from "expo-print";
import { shareAsync } from "expo-sharing";
import { useFetchTenantConfigurationQuery } from "queries/configuration.queries";
import generateEventDetails from "./generateEventDetails";
import ActivityDetails from "./ActivityDetails";
import "./Activity.css";
import { svgURL } from "utils/fileUtils";
import BottomSheet from "components/BottomSheet/BottomSheet";

interface RenderRecordProps {
  ticket: AccountTicketDetails;
  tenantConfig: TenantOptionsDetails;
}
const RenderRecord = ({ ticket, tenantConfig }: RenderRecordProps) => {
  const {
    event: { localDate, timezone, name },
  } = ticket;
  const [modalVisible, setModalVisible] = useState(false);

  const handleViewActivityDetails = async (
    accountTicket: AccountTicketDetails
  ) => {
    const html = generateEventDetails(accountTicket, tenantConfig);

    if (Platform.OS === "web") {
      setModalVisible(true);
    } else {
      // TODO: Replce with react-native-view-shot
      const { uri } = await printToFileAsync({ html });
      await shareAsync(uri, { UTI: ".pdf", mimeType: "application/pdf" });
    }
  };

  return (
    <View>
      <View>
        <View className="flex-row justify-between items-center">
          <View className="flex-row">
            <View style={{ flexShrink: 1 }}>
              <Text
                style={{ fontWeight: "700", flexWrap: "wrap", flexShrink: 1 }}
              >
                {name}
              </Text>
              <Text>
                {dayjs(localDate).tz(timezone).format("YYYY/MM/DD hh:mm A")}
              </Text>
            </View>
          </View>
        </View>
        <Button
          appearance="ghost"
          onPress={() => handleViewActivityDetails(ticket)}
        >
          View Details
        </Button>
      </View>
      <BottomSheet
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
      >
        <View style={{ flex: 1 }}>
          {tenantConfig && (
            <ActivityDetails ticket={ticket} tenantConfig={tenantConfig} />
          )}
        </View>
      </BottomSheet>
    </View>
  );
};

const Activity = () => {
  const navigation = useNavigation<NavigationProp<AccountStackParamList>>();
  const { account, accountEvents } = useAccount();
  const { data: historicalTickets, isLoading } = useFetchTicketHistoryQuery();
  const { data: tenantConfig } = useFetchTenantConfigurationQuery();

  return (
    <MainContainer
      goBackAction={() => navigation.navigate("AccountScreen")}
      grayBackground
    >
      <View style={{ padding: 15 }}>
        <BaseCard title="Activity History">
          {isLoading && (
            <BaseCardListItem
              title="Loading..."
              showArrow={false}
            ></BaseCardListItem>
          )}
          {historicalTickets?.length === 0 && accountEvents?.length === 0 && (
            <BaseCardListItem
              title="No data"
              showArrow={false}
            ></BaseCardListItem>
          )}
          {tenantConfig && (
            <ScrollView style={{ maxHeight: 500 }}>
              {accountEvents &&
                accountEvents.map((accountEvent) => (
                  <BaseCardListItem
                    key={accountEvent.groupCode.groupCode}
                    title={
                      <RenderRecord
                        ticket={accountEvent}
                        tenantConfig={tenantConfig}
                      />
                    }
                    showArrow={false}
                  />
                ))}
              {historicalTickets &&
                historicalTickets.map((ticket) => (
                  <BaseCardListItem
                    key={ticket.groupCode.groupCode}
                    title={
                      <RenderRecord
                        ticket={ticket}
                        tenantConfig={tenantConfig}
                      />
                    }
                    showArrow={false}
                  ></BaseCardListItem>
                ))}
            </ScrollView>
          )}
        </BaseCard>
        <Spacer />

        {account?.type === "FULL" && (
          <Pressable
            onPress={() => {
              /* @ts-ignore */
              navigation.navigate("Schedule", { screen: "ScheduleScreen" });
            }}
          >
            <BaseCard>
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Text>Reserve an Event</Text>
                <Chevron></Chevron>
              </View>
            </BaseCard>
          </Pressable>
        )}
      </View>
    </MainContainer>
  );
};

export default Activity;
